export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Días',
                    type: 'text',
                    key: 'days',
                },
                {
                    title: 'Descripción',
                    type: 'text',
                    key: 'rate_description'
                },
                {
                    title: 'Valor Unitario',
                    type: 'custom-html',
                    key: 'rate_amount',
                    isVisible: true,
                    modifier: (item)=>{
                        const number = Number(item);
                        return `<span>${number.toLocaleString(
                            'en-US',
                            {style: 'currency',currency: 'USD', minimumFractionDigits: 2})}</span>`;
                    }
                },
                {
                    title: 'Total',
                    type: 'custom-html',
                    key: 'total',
                    isVisible: true,
                    modifier: (item)=>{
                        const number = Number(item);
                        return `<span>${number.toLocaleString(
                            'en-US',
                            {style: 'currency',currency: 'USD', minimumFractionDigits: 2})}</span>`;
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}